import {Component, EventEmitter, Input, OnInit, Output, signal} from '@angular/core';
import {debounceTime, skip} from 'rxjs';
import {FormsModule} from '@angular/forms';
import { toObservable } from '@angular/core/rxjs-interop';
import {NgOptimizedImage} from '@angular/common';
import {SearchConfigRequest} from '../../models/search-config.model';
import {HRRequestListInput, ImsDocumentsInputs, Procedures} from '../../models/input.model';


@Component({
  selector: 'app-search-panel',
  imports: [FormsModule, NgOptimizedImage],
  templateUrl: './search-panel.component.html',
  styleUrl: './search-panel.component.css'
})
export class SearchPanelComponent implements OnInit {

  @Input() searchFields: SearchConfigRequest[] = [];

  @Output() searchParamChange = new EventEmitter<any>();

  isOpen = signal(false);
  currentParams = signal<any>({});

  inputValues: { [key: string]: any } = {};

  constructor() {
    toObservable(this.currentParams).pipe(
      skip(1),
      debounceTime(300)
    ).subscribe(params => {
      this.searchParamChange.emit(params);
    })
  }

  togglePanel() {
    this.isOpen.update(v => !v);
  }

  resetFilters() {
    this.inputValues = {}
    this.currentParams.set({});
  }

  onParamsChange(key: string, value: string) {

    const currentValue = this.inputValues[key]
    const params = {...this.currentParams()};

    if (currentValue) {
      params[key] = currentValue.toLowerCase();
    } else {
      delete params[key];
    }
    this.currentParams.set(params);

  }

  ngOnInit(): void {
    this.searchFields.filter(field => field.type === 'select').forEach(field => {
      this.inputValues[field.key] = ''
    })
  }

}
